(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noMotion = reduceMotion || root.classList.contains('fx-no-motion') || root.classList.contains('fx-design-mode');

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function once(el, key) {
    if (el['__fx' + key]) return false;
    el['__fx' + key] = true;
    return true;
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('[data-fx-header]');
    if (!header || !once(header, 'header')) return;
    var update = function () { header.classList.toggle('is-scrolled', window.scrollY > 12); };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Drawer (menú móvil) ---------- */
  function initDrawer() {
    var drawer = $('[data-fx-drawer]');
    if (!drawer || !once(drawer, 'drawer')) return;
    var toggles = $$('[data-fx-menu-toggle]');

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      root.classList.toggle('fx-lock', open);
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        var first = $('a, button', drawer);
        if (first) first.focus({ preventScroll: true });
      }
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () { setOpen(!drawer.classList.contains('is-open')); });
    });
    $$('[data-fx-menu-close]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });
    $$('[data-fx-menu-link]', drawer).forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) setOpen(false); });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024 && drawer.classList.contains('is-open')) setOpen(false);
    });
  }

  /* ---------- Reveal + contadores ---------- */
  var revealObserver = null;

  function countUp(el) {
    if (!once(el, 'count')) return;
    var target = parseFloat(el.getAttribute('data-fx-count'));
    if (isNaN(target)) return;
    var original = el.textContent;
    if (noMotion) return;
    var decimals = (String(target).split('.')[1] || '').length;
    var start = null;
    var duration = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = original;
    }
    requestAnimationFrame(step);
  }

  function initReveal(scope) {
    var items = $$('[data-fx-reveal]', scope).filter(function (el) { return !el.classList.contains('is-in'); });
    var counters = $$('[data-fx-count]', scope);

    if (noMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          revealObserver.unobserve(el);
          if (el.hasAttribute('data-fx-count')) countUp(el);
          else el.classList.add('is-in');
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    items.forEach(function (el) { revealObserver.observe(el); });
    counters.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Proceso (sección): progreso local; en desktop cede al page-scroll ---------- */
  function pageScrollVisible() {
    var el = $('[data-fx-page-scroll]');
    return !!(el && window.getComputedStyle(el).display !== 'none');
  }

  function initProcess(scope) {
    $$('[data-fx-process]', scope).forEach(function (track) {
      if (!once(track, 'process')) return;
      var steps = $$('[data-fx-step]', track);
      if (!steps.length) return;

      if (noMotion) {
        track.style.setProperty('--p', 1);
        steps.forEach(function (s, i) {
          s.classList.add('is-active');
          s.classList.toggle('is-current', i === steps.length - 1);
        });
        return;
      }

      var ticking = false;
      function update() {
        ticking = false;
        if (pageScrollVisible()) return;
        var r = track.getBoundingClientRect();
        var vh = window.innerHeight || 1;
        var p = Math.max(0, Math.min(1, (vh * 0.7 - r.top) / (r.height + vh * 0.3)));
        track.style.setProperty('--p', p.toFixed(4));
        var active = Math.round(p * steps.length);
        if (p < 0.04) active = 0;
        if (p > 0.96) active = steps.length;
        steps.forEach(function (s, i) {
          s.classList.toggle('is-active', i < active);
          s.classList.toggle('is-current', active > 0 && i === active - 1);
        });
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Page scroll Proceso: círculos anclados a cada sección ---------- */
  function initScrollRail() {
    var rail = $('[data-fx-page-scroll]');
    var main = $('#MainContent');
    if (!rail || !main || !once(rail, 'page-scroll')) return;
    var steps = $$('[data-fx-page-step]', rail);
    var line = $('.fx-page-scroll__line', rail);
    if (!steps.length) return;

    function layout() {
      if (window.getComputedStyle(rail).display === 'none') return;
      var mainRect = main.getBoundingClientRect();
      var mainTop = window.scrollY + mainRect.top;
      var startEl = document.getElementById('proceso') || $('.fx-process', main);
      var endEl = document.getElementById('producir') || $('.fx-cta', main) || document.getElementById('calidad');
      if (!startEl || !endEl) return;

      var startY = window.scrollY + startEl.getBoundingClientRect().top - mainTop + 56;
      var endY = window.scrollY + endEl.getBoundingClientRect().bottom - mainTop - 72;
      var span = Math.max(240, endY - startY);
      var n = steps.length;
      var gap = span / Math.max(1, n - 1);

      steps.forEach(function (step, i) {
        var y = startY + gap * i;
        step.style.top = Math.round(y) + 'px';
      });

      if (line) {
        rail.style.setProperty('--fx-line-top', Math.round(startY) + 'px');
        rail.style.setProperty('--fx-line-h', Math.round(span) + 'px');
      }
    }

    function update() {
      var vh = window.innerHeight || 1;
      var mark = window.scrollY + vh * 0.45;
      var mainTop = window.scrollY + main.getBoundingClientRect().top;
      var active = 0;

      steps.forEach(function (step, i) {
        var y = mainTop + (parseFloat(step.style.top) || 0);
        var on = noMotion || y <= mark;
        if (on) active = i + 1;
        step.classList.toggle('is-active', on);
        step.classList.toggle('is-current', false);
      });

      if (active > 0) {
        steps[active - 1].classList.add('is-current');
      }
      rail.style.setProperty('--p', (active / steps.length).toFixed(4));
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    layout();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      layout();
      update();
    });
    window.addEventListener('load', function () {
      layout();
      update();
    });
  }

  /* ---------- Formulario de cotización → WhatsApp ---------- */
  function initQuote(scope) {
    $$('form[data-fx-quote]', scope).forEach(function (form) {
      if (!once(form, 'quote')) return;
      var mode = form.getAttribute('data-fx-quote') || 'whatsapp';
      var number = (form.getAttribute('data-fx-wa-number') || '').replace(/\D/g, '');
      var intro = form.getAttribute('data-fx-wa-intro') || 'Hola, vengo de la página web de FALATEX. Quiero solicitar una cotización:';
      if (intro.indexOf('página web de FALATEX') === -1) {
        intro = intro.replace(/^Hola FALATEX,\s*quiero/i, 'Quiero').replace(/^Hola FALATEX,\s*/i, '');
        intro = 'Hola, vengo de la página web de FALATEX. ' + intro;
      }
      var hidden = $('[data-fx-services]', form);
      var checks = $$('[data-fx-service]', form);

      function syncServices() {
        if (!hidden) return;
        hidden.value = checks.filter(function (c) { return c.checked; }).map(function (c) { return c.value; }).join(', ');
      }
      checks.forEach(function (c) { c.addEventListener('change', syncServices); });

      function send(e) {
        if (mode === 'email') return;
        if (e) e.preventDefault();
        syncServices();
        if (!number) return;
        if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
        var lines = [intro, ''];
        $$('[data-fx-label]', form).forEach(function (field) {
          var val = (field.value || '').trim();
          if (!val) return;
          lines.push('*' + field.getAttribute('data-fx-label') + ':* ' + val);
        });
        window.location.assign('https://wa.me/' + number + '?text=' + encodeURIComponent(lines.join('\n')));
      }
      form.addEventListener('submit', send);
      var sendBtn = $('[data-fx-quote-send]', form);
      if (sendBtn) sendBtn.addEventListener('click', send);
    });
  }

  /* ---------- WhatsApp flotante ---------- */
  function initWaFloat() {
    var wrap = $('[data-fx-wa]');
    if (!wrap || !once(wrap, 'wa')) return;
    var panel = $('[data-fx-wa-panel]', wrap);
    var toggle = $('[data-fx-wa-toggle]', wrap);
    if (!panel || !toggle) return;
    function setOpen(open) {
      wrap.classList.toggle('is-open', open);
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Cerrar chat de WhatsApp' : 'Abrir chat de WhatsApp');
    }
    toggle.addEventListener('click', function () { setOpen(!wrap.classList.contains('is-open')); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    doc.addEventListener('click', function (e) {
      if (wrap.classList.contains('is-open') && !wrap.contains(e.target)) setOpen(false);
    });
  }

  /* ---------- Video ---------- */
  function initVideo(scope) {
    $$('[data-fx-video]', scope).forEach(function (frame) {
      if (!once(frame, 'video')) return;
      var btn = $('[data-fx-video-play]', frame);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var tpl = $('template[data-fx-video-template]', frame);
        if (tpl) {
          var node = tpl.content.cloneNode(true);
          $$('img, .fx-media__fill', frame).forEach(function (el) { el.remove(); });
          frame.appendChild(node);
          btn.remove();
          return;
        }
        var video = $('video', frame);
        if (video) {
          btn.remove();
          var played = video.play();
          if (played && typeof played.catch === 'function') played.catch(function () {});
        }
      });
    });
  }

  function initLazyFrames(scope) {
    var frames = $$('iframe[data-fx-lazy-src]', scope);
    if (!frames.length) return;
    var load = function (f) { if (!f.src) f.src = f.getAttribute('data-fx-lazy-src'); };
    if (!('IntersectionObserver' in window)) { frames.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '300px 0px' });
    frames.forEach(function (f) { io.observe(f); });
  }

  function initSound(scope) {
    $$('[data-fx-sound]', scope).forEach(function (box) {
      if (!once(box, 'sound')) return;
      var frame = box.closest('[data-fx-video]');
      var video = frame && $('video', frame);
      var btn = $('[data-fx-sound-toggle]', box);
      var range = $('[data-fx-sound-volume]', box);
      if (!video || !btn) return;
      video.loop = true;
      video.muted = true;
      var sync = function () {
        var on = !video.muted && video.volume > 0;
        box.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? 'Silenciar' : 'Activar sonido');
        if (range) range.style.setProperty('--v', (video.muted ? 0 : video.volume) * 100 + '%');
      };
      if (range) video.volume = parseFloat(range.value) || 0.8;
      btn.addEventListener('click', function () {
        if (video.muted && video.volume === 0) video.volume = 0.8;
        video.muted = !video.muted;
        if (range && !video.muted) range.value = video.volume;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
        sync();
      });
      if (range) {
        range.addEventListener('input', function () {
          var v = parseFloat(range.value) || 0;
          video.volume = v;
          video.muted = v === 0;
          sync();
        });
      }
      video.addEventListener('volumechange', sync);
      sync();
    });
  }

  /* ---------- Cantidad (producto y carrito) ---------- */
  function initQty(scope) {
    $$('[data-fx-qty]', scope).forEach(function (btn) {
      if (!once(btn, 'qty')) return;
      btn.addEventListener('click', function () {
        var box = btn.parentElement;
        var input = box && $('input[type="number"]', box);
        if (!input) return;
        var min = parseInt(input.getAttribute('min') || '0', 10);
        var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-fx-qty'), 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    $$('[data-fx-cart-form]', scope).forEach(function (form) {
      if (!once(form, 'cart')) return;
      var timer = null;
      $$('[data-fx-cart-qty]', form).forEach(function (input) {
        input.addEventListener('change', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var upd = doc.createElement('input');
            upd.type = 'hidden';
            upd.name = 'update';
            upd.value = '1';
            form.appendChild(upd);
            form.submit();
          }, 600);
        });
      });
    });
  }

  /* ---------- Producto ---------- */
  function swapMainImage(product, src, srcset) {
    var main = $('[data-fx-product-main]', product);
    if (!main || !src) return;
    var img = $('img', main);
    if (!img) {
      main.innerHTML = '';
      img = doc.createElement('img');
      img.alt = '';
      main.appendChild(img);
    }
    img.src = src;
    if (srcset) img.srcset = srcset; else img.removeAttribute('srcset');
  }

  function initProduct(scope) {
    $$('[data-fx-product]', scope).forEach(function (product) {
      if (!once(product, 'product')) return;
      var thumbs = $$('[data-fx-thumb]', product);

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
          swapMainImage(product, t.getAttribute('data-src'), t.getAttribute('data-srcset'));
        });
      });

      var select = $('[data-fx-variant]', product);
      if (!select) return;
      var price = $('[data-fx-price-current]', product);
      var compare = $('[data-fx-price-compare]', product);
      var sku = $('[data-fx-sku]', product);
      var add = $('[data-fx-add]', product);
      var addLabel = $('[data-fx-add-label]', product);
      var addText = addLabel ? addLabel.textContent : '';
      if (add && add.disabled) addText = 'Agregar al carrito';

      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        if (price) price.textContent = opt.getAttribute('data-price') || '';
        if (compare) {
          var c = opt.getAttribute('data-compare') || '';
          compare.textContent = c;
          compare.hidden = !c;
        }
        if (sku) {
          var s = opt.getAttribute('data-sku') || '';
          sku.textContent = 'Ref. ' + s;
          sku.hidden = !s;
        }
        var available = opt.getAttribute('data-available') === 'true';
        if (add) add.disabled = !available;
        if (addLabel) addLabel.textContent = available ? addText : 'Agotado';
        var media = opt.getAttribute('data-media');
        if (media) {
          swapMainImage(product, media, '');
          thumbs.forEach(function (t) {
            var tSrc = (t.getAttribute('data-src') || '').split('?')[0];
            t.classList.toggle('is-active', tSrc === media.split('?')[0]);
          });
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', opt.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Colección: ordenar ---------- */
  function initAutosubmit(scope) {
    $$('form[data-fx-autosubmit]', scope).forEach(function (form) {
      if (!once(form, 'auto')) return;
      $$('select', form).forEach(function (sel) {
        sel.addEventListener('change', function () { form.submit(); });
      });
    });
  }

  /* ---------- Home nav (estilo CHIKAS): /#ancla sin recargar ---------- */
  function initHomeNav() {
    if (!once(doc.documentElement, 'homenav')) return;

    function rootPath() {
      try {
        var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return r.endsWith('/') ? r : r + '/';
      } catch (_) {
        return '/';
      }
    }

    function isHomePath(pathname) {
      var root = rootPath().replace(/\/$/, '') || '';
      var path = (pathname || '/').replace(/\/$/, '') || '';
      return path === root || path === '';
    }

    function scrollToHash(hash) {
      if (!hash || hash.length < 2) {
        window.scrollTo({ top: 0, left: 0, behavior: noMotion ? 'auto' : 'smooth' });
        return;
      }
      var target = doc.querySelector(hash);
      if (!target) return false;
      target.scrollIntoView({ behavior: noMotion ? 'auto' : 'smooth', block: 'start' });
      try { history.replaceState(null, '', hash); } catch (_) {}
      return true;
    }

    doc.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || !a.href) return;
      var url;
      try { url = new URL(a.href, window.location.origin); } catch (_) { return; }
      if (url.origin !== window.location.origin) return;
      if (!isHomePath(url.pathname)) return;
      if (!isHomePath(window.location.pathname)) return;

      /* No interceptar plantillas alternas del index (?view=compra, etc.) */
      var curView = '';
      var destView = '';
      try {
        curView = new URLSearchParams(window.location.search).get('view') || '';
        destView = url.searchParams.get('view') || '';
      } catch (_) {}
      if (curView !== destView) return;

      e.preventDefault();
      if (url.hash && url.hash.length > 1) {
        if (!scrollToHash(url.hash)) window.location.href = url.pathname + url.search + url.hash;
      } else {
        scrollToHash('');
        if (window.location.hash) {
          try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (_) {}
        }
      }
    }, true);

    if (window.location.hash && window.location.hash.length > 1) {
      var tryHash = function (n) {
        if (scrollToHash(window.location.hash) || n <= 0) return;
        setTimeout(function () { tryHash(n - 1); }, 120);
      };
      requestAnimationFrame(function () { tryHash(20); });
    }
  }

  /* ---------- Login: recuperar contraseña ---------- */
  function initRecover() {
    var recover = $('#recover');
    var toggle = $('[data-fx-toggle-recover]');
    if (!recover || !toggle || !once(toggle, 'recover')) return;
    var show = window.location.hash === '#recover' || !!$('.fx-form__msg', recover);
    recover.hidden = !show;
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      recover.hidden = !recover.hidden;
      if (!recover.hidden) {
        var input = $('input[type="email"]', recover);
        if (input) input.focus();
      }
    });
  }

  /* ---------- Catálogo Compra aquí (modelos CHIKAS / KDOSH) ---------- */
  function initCatalog(scope) {
    $$('[data-fx-catalog]', scope).forEach(function (rootEl) {
      if (!once(rootEl, 'catalog')) return;
      var chips = $$('[data-fx-cat-filter]', rootEl);
      var countEl = $('[data-fx-cat-count]', rootEl);
      var emptyEl = $('[data-fx-cat-empty]', rootEl);
      var moreWrap = $('[data-fx-cat-more]', rootEl);
      var moreBtn = $('[data-fx-cat-more-btn]', rootEl);
      var statusEl = $('[data-fx-cat-status]', rootEl);
      var grid = $('.fx-lookbook__grid', rootEl);
      var searchEl = $('[data-fx-cat-search]', rootEl);
      var filter = 'all';
      var query = '';
      var pageSize = 24;
      var shown = pageSize;
      var minUnits = parseInt(rootEl.getAttribute('data-fx-min'), 10) || 6;
      var lines = [];
      var storeKey = 'fx-order-v1';

      try {
        lines = JSON.parse(window.sessionStorage.getItem(storeKey) || '[]');
        if (!Array.isArray(lines)) lines = [];
      } catch (err) { lines = []; }

      function allItems() { return $$('[data-fx-cat-item]', rootEl); }

      function apply() {
        var n = 0;
        var visible = 0;
        var q = query.trim().toLowerCase();
        allItems().forEach(function (item) {
          var brand = (item.getAttribute('data-brand') || '').toLowerCase();
          var hay = (item.getAttribute('data-q') || '').toLowerCase();
          var match = (filter === 'all' || brand === filter) && (!q || hay.indexOf(q) !== -1);
          if (!match) {
            item.classList.add('is-hidden');
            return;
          }
          n += 1;
          var keep = n <= shown;
          item.classList.toggle('is-hidden', !keep);
          if (keep) visible += 1;
        });
        if (countEl) countEl.textContent = String(n);
        if (emptyEl) {
          emptyEl.hidden = n > 0;
          emptyEl.textContent = q ? 'No hay referencias con esa búsqueda.' : 'No hay prendas en esta marca.';
        }
        if (moreWrap) {
          var rest = n - visible;
          moreWrap.hidden = rest <= 0;
          if (moreBtn && rest > 0) {
            var label = moreBtn.querySelector('span');
            if (label) label.textContent = 'Ver más modelos (' + rest + ')';
          }
        }
        chips.forEach(function (chip) {
          var on = chip.getAttribute('data-fx-cat-filter') === filter;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          filter = chip.getAttribute('data-fx-cat-filter') || 'all';
          shown = pageSize;
          apply();
        });
      });
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          shown += pageSize;
          apply();
        });
      }
      if (searchEl) {
        searchEl.addEventListener('input', function () {
          query = searchEl.value || '';
          shown = pageSize;
          apply();
        });
      }

      function brandOf(product) {
        var vendor = (product.vendor || '').toLowerCase();
        var tags = (product.tags || []).join(' ').toLowerCase();
        if (vendor.indexOf('kdosh') !== -1 || tags.indexOf('hombre') !== -1) return 'kdosh';
        return 'chikas';
      }

      function imgSrc(product) {
        var images = product.images || [];
        var src = images[0] && images[0].src ? images[0].src : '';
        if (!src) return '';
        if (src.indexOf('width=') === -1) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=1000';
        return src;
      }

      function esc(value) {
        return String(value || '').replace(/[&<>"']/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
      }

      function isAvailable(product) {
        var variants = product.variants;
        if (!variants || !variants.length) return true;
        return variants.some(function (variant) { return variant.available; });
      }

      function sizesOf(product) {
        var list = [];
        function push(value) {
          var size = String(value || '').trim();
          if (!size || list.indexOf(size) !== -1) return;
          list.push(size);
        }
        (product.sizes || []).forEach(push);
        (product.variants || []).forEach(function (variant) {
          if (variant.available === false) return;
          push(variant.option1 || variant.title);
        });
        if (!list.length) list.push('Única');
        return list;
      }

      function units() {
        return lines.reduce(function (sum, line) { return sum + line.qty; }, 0);
      }

      function saveLines() {
        try { window.sessionStorage.setItem(storeKey, JSON.stringify(lines)); } catch (err) {}
      }

      function waNumber() {
        var href = rootEl.getAttribute('data-fx-wa') || '';
        var match = href.match(/wa\.me\/(\d+)/);
        return match ? match[1] : '';
      }

      function orderText(customer) {
        var groups = [];
        lines.forEach(function (line) {
          var group = groups.filter(function (item) { return item.sku === line.sku; })[0];
          if (!group) {
            group = { sku: line.sku, brand: line.brand, name: line.name, kind: line.kind, sizes: [] };
            groups.push(group);
          }
          group.sizes.push(line);
        });
        var parts = [
          'Hola, vengo de la página web de FALATEX.',
          'Estoy consultando estas prendas al por mayor y quiero cotizar este pedido.',
          '',
          '*Pedido FALATEX*',
          '',
          '*Prendas*'
        ];
        groups.forEach(function (group, index) {
          parts.push((index + 1) + '. *' + group.brand + '* — ' + group.name);
          parts.push('Ref. *' + group.sku + '*' + (group.kind ? ' · ' + group.kind : ''));
          group.sizes.forEach(function (line) {
            parts.push('• Talla *' + line.size + '* ×' + line.qty);
          });
        });
        parts.push('');
        parts.push('*Resumen*');
        parts.push('• Unidades: *' + units() + '*');
        parts.push('• Condición: precio mayorista desde ' + minUnits + ' unidades');
        parts.push('');
        parts.push('*Datos para la cotización*');
        parts.push('• Documento: *' + customer.docType + ' ' + customer.doc + '*');
        parts.push('• Nombre: *' + customer.nombre + '*');
        parts.push('• Celular: *' + customer.telefono + '*');
        parts.push('• Ciudad: ' + customer.ciudad + (customer.departamento ? ' · ' + customer.departamento : ''));
        parts.push('• Dirección: ' + customer.direccion);
        if (customer.referencia) parts.push('• Punto de referencia: ' + customer.referencia);
        if (customer.email) parts.push('• Correo: ' + customer.email);
        parts.push('');
        parts.push('Quedo atento a la cotización y a la disponibilidad.');
        return parts.join('\n');
      }

      var dock = doc.createElement('div');
      dock.className = 'fx-order';
      dock.innerHTML = ''
        + '<button type="button" class="fx-order__fab" data-fx-order-open>'
        + '<span data-fx-order-count>0</span><span>Pedido</span></button>'
        + '<div class="fx-order__panel" data-fx-order-panel hidden>'
        + '<div class="fx-order__head"><p data-fx-order-title>Pedido mayorista</p>'
        + '<button type="button" data-fx-order-close aria-label="Cerrar pedido">✕</button></div>'
        + '<div class="fx-order__step" data-fx-order-step="cart">'
        + '<div class="fx-order__list" data-fx-order-list></div>'
        + '<div class="fx-order__actions">'
        + '<p class="fx-order__hint" data-fx-order-hint></p>'
        + '<button type="button" class="fx-btn fx-btn--block" data-fx-order-next disabled><span>Continuar con mis datos</span></button>'
        + '<button type="button" class="fx-order__clear" data-fx-order-clear>Vaciar pedido</button>'
        + '</div></div>'
        + '<div class="fx-order__step" data-fx-order-step="data" hidden>'
        + '<form class="fx-order__form" data-fx-order-form>'
        + '<p class="fx-order__lead">Estos datos llegan a FALATEX con el pedido para cotizar y despachar.</p>'
        + '<div class="fx-order__split">'
        + '<label><span>Tipo</span><select data-fx-client="docType">'
        + '<option value="CC">CC</option><option value="NIT">NIT</option><option value="CE">CE</option><option value="PA">PA</option><option value="TI">TI</option>'
        + '</select></label>'
        + '<label><span>Documento</span><input data-fx-client="doc" inputmode="numeric" maxlength="20" autocomplete="off" placeholder="1234567890"></label>'
        + '</div>'
        + '<label><span>Nombre completo</span><input data-fx-client="nombre" autocomplete="name" placeholder="Como aparece en el documento"></label>'
        + '<label><span>Celular / WhatsApp</span><input data-fx-client="telefono" type="tel" inputmode="tel" autocomplete="tel" placeholder="3001234567"></label>'
        + '<label><span>Ciudad</span><input data-fx-client="ciudad" autocomplete="address-level2" placeholder="Ciudad de entrega"></label>'
        + '<label><span>Departamento</span><input data-fx-client="departamento" autocomplete="address-level1" placeholder="Departamento"></label>'
        + '<label><span>Dirección</span><input data-fx-client="direccion" autocomplete="street-address" placeholder="Dirección de entrega"></label>'
        + '<label><span>Punto de referencia</span><input data-fx-client="referencia" autocomplete="off" placeholder="Ej. frente al parque"></label>'
        + '<label><span>Correo (opcional)</span><input data-fx-client="email" type="email" autocomplete="email" placeholder="correo@ejemplo.com"></label>'
        + '</form>'
        + '<div class="fx-order__actions">'
        + '<p class="fx-order__hint" data-fx-order-form-msg></p>'
        + '<button type="button" class="fx-btn fx-btn--wa fx-btn--block" data-fx-order-send disabled><span>Enviar cotización por WhatsApp</span></button>'
        + '<button type="button" class="fx-order__clear" data-fx-order-back>Volver al pedido</button>'
        + '</div></div>'
        + '</div>';
      doc.body.appendChild(dock);
      var panel = $('[data-fx-order-panel]', dock);
      var listEl = $('[data-fx-order-list]', dock);
      var hintEl = $('[data-fx-order-hint]', dock);
      var formMsg = $('[data-fx-order-form-msg]', dock);
      var titleEl = $('[data-fx-order-title]', dock);
      var countElOrder = $('[data-fx-order-count]', dock);
      var nextBtn = $('[data-fx-order-next]', dock);
      var sendBtn = $('[data-fx-order-send]', dock);
      var clientKey = 'fx-order-client-v1';

      function clientField(name) { return $('[data-fx-client="' + name + '"]', dock); }

      function readClient() {
        function val(name) {
          var el = clientField(name);
          return el ? String(el.value || '').trim() : '';
        }
        return {
          docType: val('docType') || 'CC',
          doc: val('doc').replace(/\D/g, '').slice(0, 20),
          nombre: val('nombre'),
          telefono: val('telefono').replace(/\D/g, ''),
          ciudad: val('ciudad'),
          departamento: val('departamento'),
          direccion: val('direccion'),
          referencia: val('referencia'),
          email: val('email')
        };
      }

      function clientValid(data) {
        return data.doc.length >= 5
          && data.nombre.length >= 3
          && data.telefono.length >= 7
          && data.ciudad.length >= 2
          && data.departamento.length >= 2
          && data.direccion.length >= 3
          && data.referencia.length >= 2;
      }

      function saveClient() {
        try { window.sessionStorage.setItem(clientKey, JSON.stringify(readClient())); } catch (err) {}
      }

      function restoreClient() {
        var saved = {};
        try { saved = JSON.parse(window.sessionStorage.getItem(clientKey) || '{}') || {}; } catch (err) { saved = {}; }
        Object.keys(saved).forEach(function (key) {
          var el = clientField(key);
          if (el && saved[key]) el.value = saved[key];
        });
      }

      function syncClient() {
        var data = readClient();
        var ok = clientValid(data) && units() >= minUnits;
        if (sendBtn) sendBtn.disabled = !ok;
        if (formMsg) {
          formMsg.textContent = ok
            ? 'Listo. Al enviar se abre WhatsApp con la cotización de FALATEX.'
            : 'Completa documento, nombre, celular, ciudad, departamento, dirección y punto de referencia.';
        }
      }

      function showStep(step) {
        $$('[data-fx-order-step]', dock).forEach(function (node) {
          node.hidden = node.getAttribute('data-fx-order-step') !== step;
        });
        if (titleEl) titleEl.textContent = step === 'data' ? 'Datos para cotizar' : 'Pedido mayorista';
        if (step === 'data') syncClient();
      }

      restoreClient();
      var clientForm = $('[data-fx-order-form]', dock);
      if (clientForm) clientForm.addEventListener('submit', function (e) { e.preventDefault(); });

      var pick = doc.createElement('div');
      pick.className = 'fx-pick';
      pick.hidden = true;
      pick.innerHTML = ''
        + '<div class="fx-pick__backdrop" data-fx-pick-close></div>'
        + '<div class="fx-pick__card" role="dialog" aria-modal="true" aria-labelledby="FxPickTitle">'
        + '<button type="button" class="fx-pick__x" data-fx-pick-close aria-label="Cerrar">✕</button>'
        + '<div class="fx-pick__top">'
        + '<img data-fx-pick-img alt="" width="120" height="160">'
        + '<div><p class="fx-pick__brand" data-fx-pick-brand></p>'
        + '<h2 id="FxPickTitle" data-fx-pick-name></h2>'
        + '<p class="fx-pick__ref" data-fx-pick-ref></p></div></div>'
        + '<div class="fx-pick__sizes" data-fx-pick-sizes></div>'
        + '<div class="fx-pick__foot">'
        + '<p data-fx-pick-sum>0 unidades de esta referencia</p>'
        + '<button type="button" class="fx-btn fx-btn--block" data-fx-pick-add disabled><span>Agregar al pedido</span></button>'
        + '</div></div>';
      doc.body.appendChild(pick);
      var pickCard = null;

      function paintOrder() {
        var total = units();
        if (countElOrder) countElOrder.textContent = String(total);
        dock.classList.toggle('has-items', total > 0);
        if (!listEl) return;
        if (!lines.length) {
          listEl.innerHTML = '<p class="fx-order__empty">Todavía no hay referencias. Elige tallas en el catálogo.</p>';
        } else {
          var groups = [];
          lines.forEach(function (line) {
            var group = groups.filter(function (item) { return item.sku === line.sku; })[0];
            if (!group) {
              group = { sku: line.sku, brand: line.brand, name: line.name, rows: [] };
              groups.push(group);
            }
            group.rows.push(line);
          });
          listEl.innerHTML = groups.map(function (group) {
            var rows = group.rows.map(function (line) {
              return '<li><span>Talla ' + esc(line.size) + '</span>'
                + '<span class="fx-order__qty">'
                + '<button type="button" data-fx-line="' + esc(line.id) + '" data-fx-step="-1" aria-label="Quitar una">−</button>'
                + '<b>' + line.qty + '</b>'
                + '<button type="button" data-fx-line="' + esc(line.id) + '" data-fx-step="1" aria-label="Sumar una">+</button>'
                + '</span></li>';
            }).join('');
            return '<article><p>' + esc(group.brand) + '</p><h3>' + esc(group.name) + '</h3>'
              + '<p class="fx-order__sku">Ref. ' + esc(group.sku) + '</p><ul>' + rows + '</ul></article>';
          }).join('');
        }
        var missing = Math.max(0, minUnits - total);
        if (hintEl) {
          hintEl.textContent = total >= minUnits
            ? 'Listo: ' + total + ' unidades. Sigue con tus datos para la cotización.'
            : 'Llevas ' + total + ' de ' + minUnits + '. Faltan ' + missing + ' para cotizar. No se vende por unidad.';
        }
        if (nextBtn) nextBtn.disabled = total < minUnits;
        syncClient();
        allItems().forEach(function (card) {
          var sku = card.getAttribute('data-sku') || '';
          var on = lines.some(function (line) { return line.sku === sku; });
          card.classList.toggle('is-in-order', on);
          var addLabel = $('.fx-look__add span', card);
          if (addLabel) addLabel.textContent = on ? 'Editar tallas' : 'Elegir tallas';
        });
      }

      function openPick(card) {
        pickCard = card;
        var sizes = (card.getAttribute('data-sizes') || 'Única').split('|').filter(Boolean);
        var img = $('[data-fx-pick-img]', pick);
        if (img) {
          img.src = card.getAttribute('data-img') || '';
          img.alt = card.getAttribute('data-name') || '';
        }
        var brand = $('[data-fx-pick-brand]', pick);
        var name = $('[data-fx-pick-name]', pick);
        var ref = $('[data-fx-pick-ref]', pick);
        if (brand) brand.textContent = card.getAttribute('data-brand-label') || '';
        if (name) name.textContent = card.getAttribute('data-name') || '';
        if (ref) ref.textContent = 'Ref. ' + (card.getAttribute('data-sku') || '');
        var box = $('[data-fx-pick-sizes]', pick);
        box.innerHTML = sizes.map(function (size) {
          var current = lines.filter(function (line) {
            return line.sku === card.getAttribute('data-sku') && line.size === size;
          })[0];
          var qty = current ? current.qty : 0;
          return '<label class="fx-size"><span>Talla ' + esc(size) + '</span>'
            + '<span class="fx-size__qty">'
            + '<button type="button" data-fx-size-step="-1" aria-label="Menos">−</button>'
            + '<input type="number" min="0" max="99" inputmode="numeric" value="' + qty + '" data-fx-size="' + esc(size) + '">'
            + '<button type="button" data-fx-size-step="1" aria-label="Más">+</button>'
            + '</span></label>';
        }).join('');
        pick.hidden = false;
        doc.documentElement.classList.add('fx-lock');
        syncPick();
      }

      function closePick() {
        pick.hidden = true;
        pickCard = null;
        doc.documentElement.classList.remove('fx-lock');
      }

      function syncPick() {
        var sum = 0;
        $$('[data-fx-size]', pick).forEach(function (input) {
          var qty = parseInt(input.value, 10) || 0;
          if (qty < 0) qty = 0;
          if (qty > 99) qty = 99;
          input.value = String(qty);
          sum += qty;
        });
        var note = $('[data-fx-pick-sum]', pick);
        if (note) note.textContent = sum + (sum === 1 ? ' unidad de esta referencia' : ' unidades de esta referencia');
        var add = $('[data-fx-pick-add]', pick);
        var already = pickCard && lines.some(function (line) { return line.sku === pickCard.getAttribute('data-sku'); });
        if (add) {
          add.disabled = sum < 1 && !already;
          var label = add.querySelector('span');
          if (label) label.textContent = sum < 1 && already ? 'Quitar del pedido' : 'Agregar al pedido';
        }
      }

      function addPick() {
        if (!pickCard) return;
        var sku = pickCard.getAttribute('data-sku') || '';
        lines = lines.filter(function (line) { return line.sku !== sku; });
        $$('[data-fx-size]', pick).forEach(function (input) {
          var qty = parseInt(input.value, 10) || 0;
          if (qty < 1) return;
          lines.push({
            id: sku + '::' + input.getAttribute('data-fx-size'),
            sku: sku,
            size: input.getAttribute('data-fx-size'),
            qty: qty,
            brand: pickCard.getAttribute('data-brand-label') || '',
            name: pickCard.getAttribute('data-name') || '',
            kind: pickCard.getAttribute('data-kind') || ''
          });
        });
        saveLines();
        closePick();
        paintOrder();
        panel.hidden = false;
        dock.classList.add('is-open');
      }

      rootEl.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-fx-pick]');
        if (!btn || !rootEl.contains(btn)) return;
        var card = btn.closest('[data-fx-cat-item]');
        if (!card || !card.getAttribute('data-sku')) return;
        openPick(card);
      });

      pick.addEventListener('click', function (e) {
        if (e.target.closest('[data-fx-pick-close]')) { closePick(); return; }
        var step = e.target.closest('[data-fx-size-step]');
        if (step) {
          var input = step.parentNode.querySelector('input');
          if (!input) return;
          input.value = String((parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-fx-size-step'), 10));
          syncPick();
          return;
        }
        if (e.target.closest('[data-fx-pick-add]')) addPick();
      });
      pick.addEventListener('input', function (e) {
        if (e.target.matches && e.target.matches('[data-fx-size]')) syncPick();
      });

      dock.addEventListener('click', function (e) {
        if (e.target.closest('[data-fx-order-open]')) {
          panel.hidden = false;
          dock.classList.add('is-open');
          return;
        }
        if (e.target.closest('[data-fx-order-close]')) {
          panel.hidden = true;
          dock.classList.remove('is-open');
          return;
        }
        if (e.target.closest('[data-fx-order-clear]')) {
          lines = [];
          saveLines();
          showStep('cart');
          paintOrder();
          return;
        }
        if (e.target.closest('[data-fx-order-next]') && units() >= minUnits) {
          showStep('data');
          var first = clientField('doc');
          if (first) first.focus();
          return;
        }
        if (e.target.closest('[data-fx-order-back]')) {
          showStep('cart');
          return;
        }
        var step = e.target.closest('[data-fx-step]');
        if (step) {
          var id = step.getAttribute('data-fx-line');
          lines.forEach(function (line) {
            if (line.id !== id) return;
            line.qty += parseInt(step.getAttribute('data-fx-step'), 10) || 0;
          });
          lines = lines.filter(function (line) { return line.qty > 0; });
          saveLines();
          paintOrder();
          return;
        }
        if (e.target.closest('[data-fx-order-send]')) {
          var customer = readClient();
          if (units() < minUnits || !clientValid(customer)) {
            syncClient();
            return;
          }
          var number = waNumber();
          if (!number) return;
          saveClient();
          window.location.assign('https://wa.me/' + number + '?text=' + encodeURIComponent(orderText(customer)));
        }
      });
      dock.addEventListener('input', function (e) {
        if (e.target.closest && e.target.closest('[data-fx-client]')) {
          if (e.target.getAttribute('data-fx-client') === 'doc') {
            e.target.value = String(e.target.value || '').replace(/\D/g, '').slice(0, 20);
          }
          saveClient();
          syncClient();
        }
      });
      doc.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePick();
      });

      function renderProducts(products) {
        var ready = (products || []).filter(function (product) {
          return product && product.images && product.images.length && isAvailable(product);
        });
        if (!grid || !ready.length) return false;
        $$('.fx-look--fallback, [data-fx-live-item]', rootEl).forEach(function (node) { node.remove(); });
        var html = ready.map(function (product, index) {
          var brand = brandOf(product);
          var title = (product.title || 'Referencia').replace(/\s+/g, ' ').trim();
          var skuMatch = title.match(/(\d{4,}-\d{2})\s*$/);
          var n = index + 1;
          var sku = skuMatch ? skuMatch[1] : ('FX-' + (n < 10 ? '0' : '') + n);
          var name = skuMatch ? title.replace(/\s*\d{4,}-\d{2}\s*$/, '').trim() : title;
          var kind = product.product_type || 'Denim';
          var who = brand === 'kdosh' ? 'Caballero' : 'Dama';
          var brandLabel = brand === 'kdosh' ? 'KDOSH' : 'CHIKAS';
          var src = imgSrc(product);
          var sizes = sizesOf(product).join('|');
          var media = src
            ? '<img src="' + esc(src) + '" alt="' + esc(name) + '" width="800" height="1066" loading="lazy">'
            : '';
          var q = (title + ' ' + kind + ' ' + brandLabel).toLowerCase();
          return ''
            + '<article class="fx-look" data-fx-cat-item data-fx-live-item data-brand="' + brand + '"'
            + ' data-sku="' + esc(sku) + '" data-name="' + esc(name) + '" data-kind="' + esc(kind) + '"'
            + ' data-brand-label="' + brandLabel + '" data-img="' + esc(src) + '"'
            + ' data-sizes="' + esc(sizes) + '" data-q="' + esc(q) + '">'
            + '<button type="button" class="fx-look__media" data-fx-pick>'
            + media
            + '<span class="fx-look__ref">' + esc(sku) + '</span>'
            + '<span class="fx-look__badge">Disponible</span>'
            + '<span class="fx-look__hover"><span>Elegir tallas</span></span>'
            + '</button>'
            + '<div class="fx-look__meta">'
            + '<div class="fx-look__meta-top"><p class="fx-look__brand">' + brandLabel + '</p><p class="fx-look__detail">' + esc(kind) + ' · ' + who + '</p></div>'
            + '<h3 class="fx-look__name">' + esc(name) + '</h3>'
            + '<div class="fx-look__foot"><p class="fx-look__price"><span>Mayoreo</span><strong>Consultar</strong></p><p class="fx-look__note">Desde ' + minUnits + ' uds. en el pedido</p></div>'
            + '</div>'
            + '<button type="button" class="fx-btn fx-btn--sm fx-look__add" data-fx-pick><span>Elegir tallas</span></button>'
            + '</article>';
        }).join('');
        grid.insertAdjacentHTML('afterbegin', html);
        paintOrder();
        return true;
      }

      function fetchJson(url, ms) {
        var ctrl = window.AbortController ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms || 6000) : null;
        return fetch(url, { credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
          .then(function (res) {
            if (!res.ok) throw new Error('bad');
            return res.json();
          })
          .then(function (data) {
            if (timer) clearTimeout(timer);
            return (data && data.products) || [];
          })
          .catch(function (err) {
            if (timer) clearTimeout(timer);
            throw err;
          });
      }

      function loadFeed() {
        var localUrl = rootEl.getAttribute('data-fx-catalogo');
        var liveUrl = rootEl.getAttribute('data-fx-feed-live');
        if (!window.fetch || (!localUrl && !liveUrl)) {
          $$('.fx-look--fallback', rootEl).forEach(function (node) { node.classList.remove('fx-look--fallback'); });
          if (statusEl) statusEl.hidden = true;
          apply();
          return;
        }

        function show(products) {
          if (!renderProducts(products)) throw new Error('empty');
          if (statusEl) statusEl.hidden = true;
          shown = pageSize;
          apply();
        }

        var localLoad = localUrl ? fetchJson(localUrl, 8000) : Promise.reject();
        localLoad.then(show).catch(function () {
          $$('.fx-look--fallback', rootEl).forEach(function (node) { node.classList.remove('fx-look--fallback'); });
          if (statusEl) statusEl.textContent = 'No se pudo cargar el inventario activo.';
          apply();
        });

        if (!liveUrl) return;
        var join = liveUrl.indexOf('?') === -1 ? '?' : '&';
        fetchJson(liveUrl + join + 'limit=250', 5000).then(function (products) {
          if (products.length) show(products);
        }).catch(function () {});
      }

      paintOrder();
      loadFeed();
    });
  }

  /* ---------- Init ---------- */
  function initScope(scope) {
    initReveal(scope);
    initProcess(scope);
    initQuote(scope);
    initVideo(scope);
    initSound(scope);
    initLazyFrames(scope);
    initQty(scope);
    initProduct(scope);
    initAutosubmit(scope);
    initCatalog(scope);
  }

  /* WhatsApp e Instagram abren en la misma pestaña, sin aviso de ventana nueva. */
  function initDirectApps() {
    if (!once(doc.documentElement, 'directapps')) return;
    doc.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!/wa\.me|api\.whatsapp\.com|instagram\.com|instagr\.am/i.test(href)) return;
      e.preventDefault();
      window.location.assign(a.href);
    }, true);
  }

  function init() {
    initHeader();
    initDrawer();
    initHomeNav();
    initDirectApps();
    initWaFloat();
    initRecover();
    initScrollRail();
    initScope(doc);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  doc.addEventListener('shopify:section:load', function (e) {
    initHeader();
    initDrawer();
    initScope(e.target);
  });
  doc.addEventListener('shopify:block:select', function (e) {
    $$('[data-fx-reveal]', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });
})();
